import { render, staticRenderFns } from "./WeightField.vue?vue&type=template&id=32c110b5&"
import script from "./WeightField.vue?vue&type=script&lang=ts&"
export * from "./WeightField.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports